import React from "react";
import {useTranslation} from "react-i18next";

interface EmailInputProps {
  email: string;
  setEmail: (value: string) => void;
  isValid: boolean;
  errorMessage: string;
}

export const EmailInput: React.FC<EmailInputProps> = ({
                                                        email,
                                                        setEmail,
                                                        isValid,
                                                        errorMessage,
                                                      }) => {
  const { t } = useTranslation();
  return (
    <div className="my-4">
      <label className="block text-sm font-medium mb-2 text-left" htmlFor="email">
        {t('SignupEmail')}
      </label>
      <input
        type="email"
        id="email"
        placeholder={t('SignupEmailPlaceholder')}
        className={`w-full rounded-md px-3 py-2 bg-white text-black border-2 ${
          isValid ? "border-black" : "border-red-500"
        }`}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      {!isValid && <p className="text-red-500 text-sm mt-2">{errorMessage}</p>}
    </div>
  );
}